<template>
  <div class="g-alarm-handler__row alarm-messages">
    <h3
      class="alarm-messages__title"
      :class="[computedNotesClass]"
    >
      {{ $t('messages.alarms.notes') }}
    </h3>

    <div
      v-if="notes && notes.length"
    >
      <div 
        v-for="{lastedit, when, msguserid, first_name, last_name, message} in notes"
        :key="when"
        :class="{'g-text alarm-messages__note--reply': msguserid !== parseInt(userId)}"
        class="g-text alarm-messages__note"
      >
        <p>
          <strong>{{ first_name + ' ' + last_name }} - {{ getDateTime(lastedit || when) }}</strong>
          <br>
          <br>
          {{ message }}
        </p>
      </div>
    </div>
    <div
      v-else
      class="g-text alarm-messages__note"
    >
      <slot v-if="receivedNotes">
        {{ $t('messages.alarms.noNotes') }}
      </slot>
      <slot v-else>
        {{ $t('messages.sharedTexts.status.loading') }}
      </slot>
    </div>

    <textarea
      v-model="note"
      class="alarm-messages__text-input"
      :placeholder="$t('messages.alarms.pleaseWrite')"
    />

    <div class="g-text g-text--center alarm-handler__buttons">
      <button
        type="submit"
        class="g-btn g-btn--rounded g-btn--blue"
        @click.stop="submitClicked"
      >
        {{ $t('messages.alarms.addNote') }}
      </button>
    </div>
  </div>
</template>

<script>
import {MicroService} from '@/assets/javascript/mixins/Mixins'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment'

export default {
  name: 'AlarmMessages',
  components: {
  },
  mixins: [MicroService],
  props: {
    type: {
      type: Number,
      default: 1
    },
    origin: {
      type: Number,
      default: 0
    },
    dateTimeFormat: {
      type: String,
      default: 'LT'
    },
    userId: {
      type: String,
      default: ''
    },
    deviceId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      receivedNotes: false,
      note: null,
      notes: []/*[{
        ctrlid: '1254',
        id: '35',
        message: 'test',
        name: 'Alarm',
        oid: '89338295',
        origin: '9', // alarm id
        userid: '606',
        when: '2019-08-21 08:34:38.60153'
      }]*/
    }
  },
  computed: {
    computedNotesClass() {
      return (this.notes.length) ? 'alarm-handler__title--underlined' : ''
    }
  },
  watch: {
    origin: {
      handler() {
        this.sendMicroServiceRequest({
          method: 'GET', // 'type_id', 'origin_id', 'device_id' 
          url: `api/authenticated/function/getmessages?type_id=${parseInt(this.type)}&origin_id=${parseInt(this.origin)}&device_id=${parseInt(this.deviceId)}`
        })
        .then((response) => {
          console.log(response.data.getmessages)
          Array.isArray(response.data.getmessages)
          ? this.$set(this, 'notes', response.data.getmessages)
          : console.error(response)

          this.receivedNotes = true
        }).catch(console.error)

      },
      immediate: true
    }
  },
  methods: {
    getDateTime: (timestamp) => moment(timestamp).format('MMM Do YYYY, h:mm A'),
    submitClicked() {
      if(!isEmpty(this.note)) { // Note contains data
        this.sendMicroServiceRequest({
          method: 'GET', // 'typeid', 'origin', 'deviceid', 'msg_message'
          url: `api/authenticated/function/addmessage?typeid=${parseInt(this.type)}&origin=${parseInt(this.origin)}&deviceid=${parseInt(this.deviceId)}&msg_message=${String(this.note)}`
        })
        .then((response) => {
          console.log(response.data.addmessage)
          response.data.addmessage
          ? this.notes.push(response.data.addmessage)
          : console.error(response)

          this.receivedNotes = true
        }).catch(console.error)

        this.note = null // clears the textarea
      }
    }
  }
}
</script>

<style lang="scss">
.alarm-messages {
  margin-top: 20px;
  textarea {
    box-sizing: border-box;
    width: 100%;
    min-height: 100px;
    resize: vertical;
  }

  &__title {
    padding-bottom: 5px;
    &--underlined {
      border-bottom: 1px solid $color-grey-darker;
    }
  }

  &__note {
    background: lighten($color-blue-marine, 50);
    padding: 5px 20px;
    border-radius: $application-base-border-radius;
    margin: 5px 0;

    strong {
      padding-bottom: 5px;
    }

    &--reply {
      background: lighten($color-green-ok, 50);
    }
  }
}
</style>
